<template>
  <div class="d-flex flex-1-1 fd-column bg-white">
    <div class="d-none:t">
      <button
          v-if="isInfoMode"
          class="btn-ghostfilled bd-b-depot btn-sm w-100 jc-end m-b-2"
          @click="showMessagesView">
        Show Messages
        <vk-icon name="chevronright" size="16" class="m-l-1 c-depot"/>
      </button>
      <button
          v-else-if="isMessagesMode"
          class="btn-ghostfilled bd-b-depot btn-sm w-100 jc-start"
          @click="showInfoView">
        <vk-icon name="chevronleft" size="16" class="m-r-1 c-depot"/>
        Show Pro Info
      </button>
    </div>
    <div v-if="job" class="d-flex flex-1-1 fw-nowrap">
      <div v-if="isInfoMode" class="INFO-VIEW-WRAPPER">
        <info
            :job="job"
            :skills-profile-id="skillsProfileId"
            class="h-100 bd-r-gray30"/>
      </div>

      <div v-if="isMessagesMode" class="d-flex flex-1-1">
        <messages-view
            v-bind="getInfo(job.order_hash, skillsProfileId)"
            :job="job"
            :skills-profile-id="skillsProfileId"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import workOrder from '@/mixins/work-order';
import MessagesView from './components/MessagesView';
import Info from './components/Info';

export default {
  name: 'message',
  title: 'Message',
  components: {
    MessagesView,
    Info,
  },
  mixins: [
    workOrder,
  ],
  props: {
    jobId: {
      type: [String, Number],
      required: true,
    },
    skillsProfileId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      mode: 'messages',
    };
  },
  computed: {
    ...mapGetters('consumer/messages', ['getInfo']),
    ...mapGetters('consumer/jobs', ['getJob']),
    job () {
      return this.workOrder;
    },
    isInfoMode () {
      return !this.$device.isMobile || this.mode === 'info';
    },
    isMessagesMode () {
      return !this.$device.isMobile || this.mode === 'messages';
    },
  },
  mounted () {
    this.fetchWorkOrder({ jobId: this.jobId, includePublicProfiles: true });
  },
  methods: {
    showInfoView () {
      this.mode = 'info';
    },
    showMessagesView () {
      this.mode = 'messages';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .INFO-VIEW-WRAPPER {
    flex: 1 1 auto;

    @include tablet {
      flex: 0 0 auto;
      width: 33%;
      max-width: 400px;
    }
  }
</style>
